module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-hero-1920x1080-3c1156d5243d0523bdb77728e156cafd.jpg";